import e from"styled-components";const i=e.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	border-radius: ${({borderRadius:e})=>`${e}px`};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	background-color: ${({backgroundColor:e})=>e};
	color: ${({color:e})=>e};
	padding: 16px;
	height: 100%;
	box-sizing: border-box;
`,o=e.div`
	display: grid;
	place-content: center;
	position: relative;
	min-height: 152px;
	background-color: ${({accentColor:e})=>e}99;
	border-radius: ${({borderRadius:e})=>e}px;
	overflow: hidden;
`,t=e.div`
	position: absolute;
	inset: 0;
	display: grid;
	place-content: center;
	width: 200px;
	place-self: center;
`,r=e.div`
	width: 86px;
	height: 82px;
	background-color: #fff;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	border-radius: ${({borderRadius:e})=>e}px;
	z-index: 10;
	padding: 9px;
	box-sizing: border-box;
	margin: 0 auto;
`,n=e.span`
	font-size: 14px;
	font-weight: 600;
	text-transform: capitalize;
	color: #000000;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	-webkit-box-orient: vertical;
	overflow: hidden;
`,d=e.span`
	text-align: right;
	font-size: 42px;
	font-weight: 600;
	line-height: 0.8;
	color: #000000;
`,a=e.div`
	width: 86px;
	height: 84px;
	position: absolute;
	border-radius: ${({borderRadius:e})=>e}px;
	background-color: ${({accentColor:e})=>e};
	transform: rotate(6.638deg);
	left: 15%;
	bottom: -20%;
`,p=e.div`
	width: 86px;
	height: 84px;
	position: absolute;
	border-radius: ${({borderRadius:e})=>e}px;
	background-color: ${({accentColor:e})=>e};
	transform: rotate(-6.735deg);
	left: 50%;
	top: -20%;
`,l=e.div`
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	gap: 16px;
	height: 100%;
`,s=e.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
`,c=e.h1`
	font-size: 22px;
	margin: 0;
	font-weight: 600;
	min-height: 22px;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,x=e.p`
	font-size: 14px;
	margin: 0;
	font-weight: 400;
	opacity: 0.6;
	line-height: 18px;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,b=e.div`
	display: flex;
	align-items: center;
	justify-content: ${({hasLink:e})=>e?"space-between":"flex-end"};
`,g=e.span`
	font-size: 14px;
	font-weight: 400;
	color: ${({color:e})=>e};
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
	border-radius: 9999px;
	width: fit-content;
	max-width: 80%;
	text-overflow: ellipsis;
	overflow: hidden;
	display: inline-block;
`,u=e.div`
	display: grid;
	place-content: center;
	padding: 5px;
	border-radius: 50%;
	background-color: ${({backgroundColor:e})=>e};
	width: 24px;
	height: 24px;
	box-sizing: border-box;
`;e.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
`,e.div`
	background: url(${({imageUrl:e})=>e});
	background-size: cover;
	background-position: ${({position:e})=>e?`${e.x}% ${e.y}%`:"center"};
	border-radius: ${({borderRadius:e})=>e-3+"px"};
	position: relative;

	${({isOneColumn:e})=>e?"\n      width: 284px;\n      min-height: 241px;\n      ":"\n      min-height: 170px;\n  "}
`;export{u as ArrowContainer,l as CardBody,i as CardContainer,s as CardContentContainer,t as CardDecorationContainer,a as CardDecorationFirst,p as CardDecorationSecond,b as CardFooter,o as CardHeader,c as CardHeading,g as CardLabel,x as CardParagraph,d as CardValue,r as CardValueContainer,n as CardValuePrefix};
